import { SchemaModifierBaseConvertor } from './schemaModifierBase.convertor';

export class DeriveConvertor extends SchemaModifierBaseConvertor {
}
